import { z } from 'zod'

export const UnitOccupancyStatusEnum = z.enum(['Occupied', 'Vacant'])

export type UnitOccupancyStatus = z.infer<typeof UnitOccupancyStatusEnum>

export const LeaseStatusEnum = z.enum(['Applicant', 'Current', 'Future', 'Notice', 'Past'])

export type LeaseStatus = z.infer<typeof LeaseStatusEnum>

export interface UnitLease {
  id: number
  pmsLeaseId: string
  leaseStatus: LeaseStatus | null
  leaseStart: number | null
  leaseEnd: number | null
  moveInDate: number | null
  moveOutDate: number | null
}

export interface UnitLeaseResident {
  clientId: number | null
  firstName: string | null
  lastName: string | null
  avatar: string | null
  email: string | null
  leaseRole: string | null
  isLeaseSigner: boolean
  isHeadOfHousehold: boolean
  isGuarantor: boolean | null
  isDependent: boolean | null
  isMinor: boolean | null
  moveInDate: number | null
  moveOutDate: number | null
}

export interface UnitLeaseWithResidents extends UnitLease {
  residents: UnitLeaseResident[]
}

export interface UnitListItem {
  id: number
  unit: string
  unitId: string | null
  unitType: string | null
  buildingId: number | null
  occupancyStatus: UnitOccupancyStatus
  currentLease: UnitLease | null
  futureLeases: UnitLease[]
  residents: UnitLeaseResident[]
}

export interface UnitOccupancyCounts {
  occupied: number
  vacant: number
}

export interface UnitDetails {
  id: number
  unit: string
  unitId: string | null
  unitType: string | null
  buildingId: number | null
  buildingName: string | null
  occupancyStatus: UnitOccupancyStatus
  currentLease: UnitLease | null
  futureLeases: UnitLease[]
  residents: UnitLeaseResident[]
  street: string | null
  city: string | null
  state: string | null
  zip: string | null
  floor: string | null
  buildingNumber: string | null
  squareFeet: number | null
  economicStatus: string | null
}

export interface LeaseFinancial {
  termMonths: number | null
  monthlyRentCents: number | null
  rentDueDay: number | null
  rentFrequency: string | null
  arBalanceCents: number | null
  securityDepositCents: number | null
}

export interface LeaseDetails {
  id: number
  signedDate: number | null
  leaseType: string | null
  financial: LeaseFinancial
}
